import styled from "styled-components"
import { Container, Grid } from "@mui/material"
import CustomImage from "../../components/custom-image/custom-image.component"
import Typography from "@mui/material/Typography"
import SectionWrapper from "../../components/section-wrapper/section-wrapper.component"

export const Section = styled(SectionWrapper)`
  background-color: ${({ theme }) => theme.palette.primary.light};
  padding-top: 0;
`
export const Wrapper = styled(Container)`
  max-width: 780px;
`
export const Title = styled.h3`
  color: ${({ theme }) => theme.palette.primary.main};
  font-weight: normal;
  margin-top: 0;
  font-size: ${({ theme }) => theme.typography.pxToRem(30)};
  line-height: 1.33em;
  margin-bottom: 2rem;
  ${({ theme }) => theme.breakpoints.down("md")} {
    font-size: ${({ theme }) => theme.typography.pxToRem(24)};
    margin-bottom: 1rem;
  }
`
export const Column = styled.div`
  color: ${({ theme }) => theme.palette.primary.main};
  h3 {
    font-weight: bold;
    letter-spacing: -0.5px;
    font-size: ${({ theme }) => theme.typography.pxToRem(26)};
    margin: 0;
  }
  p {
    margin-top: 0;
    font-size: 1rem;
    color: ${({ theme }) => theme.palette.text.secondary};
  }
`

export const TestimonialWrapper = styled.div`
  margin-top: 2rem;
  display: flex;
  column-gap: 0.5rem;
  //justify-content: space-between;
`
export const ImageContainer = styled.div``
export const TestimonialContainer = styled.div``
export const Quotes = styled(CustomImage)`
  width: 25px !important;
  // img {
  //   width: 100%;
  // }
  // ${({ theme }) => theme.breakpoints.down("sm")} {
  //   display: none;
  // }
`

export const Testimonial = styled.p`
  font-size: ${({ theme }) => theme.typography.pxToRem(21)};
  line-height: 1.52em;
  color: ${({ theme }) => theme.palette.text.secondary};
  font-weight: normal;
  margin-bottom: 1rem;
  margin-top: 0;
`

export const AuthorContainer = styled(Grid)`
  height: 80px;
  margin-top: 1em;
`

export const AuthorImageContainer = styled(Grid)``

export const AuthorImage = styled(CustomImage)`
  width: 40px;
  height: 40px;
  overflow: hidden;
  border-radius: 50%;
`

export const AuthorName = styled(Typography)`
  color: ${({ theme }) => theme.palette.primary.main};
  font-size: 1rem;
  line-height: 1.5;
  letter-spacing: -0.2px;
  margin-top: 0.5em;
  font-weight: 500;
`
export const Role = styled(Typography)`
  color: ${({ theme }) => theme.palette.text.tertiary};
  font-size: 1rem;
  line-height: 1.5;
  letter-spacing: -0.2px;
`
export const Item = styled(Grid)`
  max-width: 24px;
`
